export default __webpack_public_path__ + "media/icons/icons_stars_inactive_lrg-a0d4ffbc.svg";